export const UPDATE_GAZE_SWITCH_SETTINGS =
  'cboard/GazeSwitchProvider/UPDATE_GAZE_SWITCH_SETTINGS';
